import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { ServiceUrl } from "../../utils/serviceUrl";
import { DB_POSTFIX, getFileLiveUrl } from "../../utils";

const WelcomeBanner = (props) => {
  const [dataList, setDataList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    axios.get(ServiceUrl.LIST_PAGES + "?type=welcomebanner").then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
        setShowModal(true);
      }
    });
  };

  const field = (fieldName) => dataList?.[0]?.[fieldName] || "";

  return (
    <>
      {dataList &&
        dataList.length > 0 &&
        field("show_on_top_scroll") == "1" && (
          <div>
            <Modal show={showModal} size="lg">
              <Modal.Body className="text-center">
                <a
                  className="modal_custom_close_icon_ps"
                  onClick={(e) => setShowModal(false)}
                >
                  x
                </a>
                {field("content") ? (
                  <a href={field("content")} target="_blank">
                    <img
                      src={getFileLiveUrl(field("feature_image"))}
                      style={{ width: "100%" }}
                    />
                  </a>
                ) : (
                  <img
                    src={getFileLiveUrl(field("feature_image"))}
                    style={{ width: "100%" }}
                  />
                )}
              </Modal.Body>
            </Modal>
          </div>
        )}
    </>
  );
};

export default WelcomeBanner;
